import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationPTBR from "./locales/pt-BR.json";
import translationENG from "./locales/en.json";
import translationES from "./locales/es.json";
import {
  I18N_STORAGE_KEY,
  resolveHostDefaultLocale,
  resolveInitialLocale,
} from "./helpers/hostDefaultLocale";

const hostname =
  typeof window !== "undefined" ? window.location.hostname : "localhost";
const navigatorLanguage =
  typeof navigator !== "undefined" ? navigator.language : null;
const hostDefaultLocale = resolveHostDefaultLocale(hostname, navigatorLanguage);

const resources = {
  "pt-BR": {
    translation: translationPTBR,
  },
  en: {
    translation: translationENG,
  },
  es: {
    translation: translationES,
  },
};

const storedRaw =
  typeof localStorage !== "undefined"
    ? localStorage.getItem(I18N_STORAGE_KEY)
    : null;

const initialLocale = resolveInitialLocale({
  hostname,
  storedLocale: storedRaw,
  navigatorLanguage,
});

if (typeof localStorage !== "undefined") {
  localStorage.setItem(I18N_STORAGE_KEY, initialLocale);
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLocale,
    fallbackLng: hostDefaultLocale,
    supportedLngs: ["pt-BR", "en", "es"],
    nonExplicitSupportedLngs: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: I18N_STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
      bindI18n: "languageChanged",
      bindI18nStore: "added removed",
    },
  });

export default i18n;
